
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
declare var gtag;


import { MiradoresService } from '../../services/miradores.service';
import { Mirador } from '../../models/mirador';

import { ICarouselItem } from '../carousel/Icarousel-item.metadata';

import { Share } from '@capacitor/share/dist/esm';
import { ClipboardService } from 'ngx-clipboard';


import { UtilService } from '../../services/util.service';
import { BusinessHour } from '../../models/business-hour';

import { IMAGES_PATH } from 'src/app/enums & constants/paths.constants';
import { OrganizerService } from 'src/app/services/organizer.service';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { LinkManagerService } from 'src/app/services/link-manager.service';
import { AlbumsService } from 'src/app/services/albums.service';
import { Subject, takeUntil } from 'rxjs';


export interface Tag {
  name: string;
}

export interface TabContent {
  title: string;
  content: any;
  type: number
}

@Component({
  selector: 'app-mirador-map-card-album',
  templateUrl: './mirador-map-card-album.component.html',
  styleUrls: ['./mirador-map-card-album.component.scss']
})
export class MiradorMapCardAlbumComponent implements OnInit, OnDestroy {

  customColors: string[] = ['#f50', '#2db7f5', '#87d068', '#108ee9'];

  imagesPath = IMAGES_PATH;
  isModalVisible: boolean = false;
  isBlockComidasVisible: boolean = false;

  miradorSelected: Mirador;
  iSMinicardShowed: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private albumsService: AlbumsService,
    public ORGService: OrganizerService,
    private utilService: UtilService,
    private router: Router,
    private linkManager: LinkManagerService) {
  }

  ngOnInit(): void {
    this.albumsService.$miradorSelected
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((selected) => {
      if (selected) {
        this.miradorSelected = selected;
        this.initBusinessHours();
      }
    })

    this.ORGService.$isCarouselOpen
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((shouldDisplayCard) => {
      this.iSMinicardShowed = shouldDisplayCard;
    })

  }


  initBusinessHours() {
    this.labelForToday();
  }


  toggletCard(source) {
    if (source == 'down' && this.iSMinicardShowed == false) {
      this.ORGService.setCarruselStatus('close');
      return;
    }

    if (source == 'up' && this.iSMinicardShowed == true) {
      return;
    }

    this.ORGService.setDisplayMiradorDetailStatus(this.miradorSelected);
    this.seeDetail(this.miradorSelected);
  }

  async onShare() {
    let url = location.href;
    if (url.includes('localhost')) {
      url = url.replace('http', 'https').replace('localhost', 'med.miradores.co');
    }

    if (url.includes('capacitor')) {
      url = url.replace('capacitor', 'https');
    }

    await Share.share({
      title: 'Miradores Medellín',
      text: this.miradorSelected.name,
      url: url,
      dialogTitle: 'Miradores Medellín',
    });

  }


  registrarEvento() {
    gtag('event', 'Abrir en GMaps', {
      'item_list_name': this.miradorSelected.name
    });
  }


  isOpen() {
    let businessHours = this.miradorSelected.businessHours;
    if (businessHours?.isOpen == null) {
      if (businessHours.startHourToday != null && businessHours.endHourToday != null) {

        businessHours.isOpen = this.utilService.isOpen(businessHours);
      }
    }

    return businessHours.isOpen;
  }

  labelForToday() {
    let bHours = this.miradorSelected.businessHours;
    let content = bHours.content;
    switch (bHours?.type) {
      case 1:
        bHours.labelToDisplay = bHours.labelForToday;
        break;
      case 2:
        content = bHours.content;
        this.calculateHours(bHours, content, false);
        bHours.labelToDisplay = bHours.labelForToday;
        break;
      case 3:
        let isBefore: boolean = this.utilService.isBeforeToSixAM();
        bHours.labelForToday = isBefore ?
          this.utilService.getContentByDayOfWeek(bHours, this.utilService.getYesterdayAsString()) :
          this.utilService.getContentByDayOfWeek(bHours, this.utilService.getTodayAsString());

        content = bHours.labelForToday;
        if (this.utilService.getStringHourByContent(content) != 'Cerrado') {
          this.calculateHours(bHours, content, isBefore);
        }
        bHours.labelToDisplay = isBefore ? this.utilService.getYesterdayAsString() : "Hoy";
        break;
    }
    this.isOpen();
  }

  calculateHours(bHours: BusinessHour, content: string, isBefore: boolean) {

    bHours.startHourToday = this.utilService.getStartHourByContent(content, isBefore);
    bHours.endHourToday = this.utilService.getEndHourByContent(content, bHours.startHourToday, isBefore);

    bHours.showMinutes = this.utilService.anyDateHaveMinutes(bHours.startHourToday, bHours.endHourToday);
  }

  displayFullHours() {
    let bHours = this.miradorSelected.businessHours;
    if (bHours.contentToDisplay.length == 0) {
      bHours.contentSplitted.map(day => {
        let startHourDay = this.utilService.getStartHourByContent(day);
        let endHourDay = this.utilService.getEndHourByContent(day, startHourDay);
        let showMinutesDay = this.utilService.anyDateHaveMinutes(startHourDay, endHourDay);
        let hasServiceDay = startHourDay.isValid();
        bHours.contentToDisplay.push({ label: day, startHour: startHourDay, endHour: endHourDay, showMinutes: showMinutesDay, hasService: hasServiceDay });
      })
    }

    this.isModalVisible = true;
  }

  closeModalHours() {
    this.isModalVisible = false;
  }

  seeOnGMaps() {
    window.open(this.miradorSelected.seeOnMapsUrl, "_blank");
  }

  getInstPermaLink() {
    let url: string = `https://www.instagram.com/reel/${this.miradorSelected.reelInstId}/?utm_source=ig_embed&amp;utm_campaign=loading`;
    return (url);
  }

  onTabChange(evt) {
    if (evt.tab.nzTitle == 'Scan QR') {
      //this.openScanQR = true;
    } else {
      //this.openScanQR = false;
    }
  }

  generateAndOpenDinamikLink(path) {
    const dinamikLink = this.linkManager.generateDinamicLink(path);
    window.open(dinamikLink, '_self')
  }

  seeDetail(mirador: Mirador) {
    const miradorNameNormalize = this.albumsService.getNormalizedMiradorNameForURL(mirador.name);
    if (this.linkManager.isMobileWeb()) {
      this.generateAndOpenDinamikLink('mirador/' + miradorNameNormalize);
    } else {
      this.router.navigate(['/mirador', miradorNameNormalize], {
        queryParams: { utm_source: 'app' }
      });
    }
  }

  getUrlImage(urlImage) {
    return `url('${urlImage}')`;
  }

  closeCard() {
    this.ORGService.setCarruselStatus('close');
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
